var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "messaging-description",
      attrs: { "data-cy": "messaging-description-page" },
    },
    [
      _c(
        "cd-modal",
        {
          staticClass: "modal",
          attrs: {
            title: "Please Note",
            large: true,
            visible: _vm.isVerbalModalVisible,
          },
          on: {
            close: function ($event) {
              _vm.isVerbalModalVisible = false
            },
            confirm: _vm.handleVerbalModalConfirm,
          },
        },
        [
          _c("vwc-icon", {
            staticClass: "modal-icon",
            attrs: { type: "warning-line" },
          }),
          _c("p", { staticClass: "modal-text" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("smsRegistrations.messagingDescriptionModalText")
                ) +
                " "
            ),
          ]),
        ],
        1
      ),
      _c("h5", [
        _vm._v(_vm._s(_vm.$t("smsRegistrations.messagingDescriptionHeader"))),
      ]),
      _c("span", { staticClass: "description-sub-title" }, [
        _vm._v(
          _vm._s(_vm.$t("smsRegistrations.messagingDescriptionSubHeader1"))
        ),
      ]),
      _c("span", [
        _vm._v(
          _vm._s(_vm.$t("smsRegistrations.messagingDescriptionSubHeader2"))
        ),
      ]),
      _c(
        "messaging-description-check-box",
        {
          staticClass: "messaging-description-check-box",
          attrs: {
            "tool-tip-info": _vm.toolTips[3],
            "is-ack-checked":
              _vm.messagingDescriptionData.impliedCheckBox.isCheck,
            header: _vm.messagingDescriptionData.impliedCheckBox.header,
            disabled: _vm.readOnly,
            "data-cy": "messaging-description-implied-check-box",
          },
          on: { checkBox: _vm.impliedCheckBoxChanged },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.messagingDescriptionData.impliedCheckBox.isCheck,
                  expression:
                    "messagingDescriptionData.impliedCheckBox.isCheck",
                },
              ],
              attrs: { slot: "messaging-description-check-box-body" },
              slot: "messaging-description-check-box-body",
            },
            [
              _c("div", { staticClass: "implied-consent" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "smsRegistrations.messagingDescriptionImpliedConsentCheckBoxDescription"
                      )
                    ),
                  },
                }),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "messaging-description-check-box",
        {
          staticClass: "messaging-description-check-box",
          attrs: {
            "tool-tip-info": _vm.toolTips[1],
            "is-ack-checked":
              _vm.messagingDescriptionData.verbalCheckBox.isCheck,
            header: _vm.messagingDescriptionData.verbalCheckBox.header,
            disabled: _vm.readOnly,
            "data-cy": "messaging-description-verbal-check-box",
          },
          on: { checkBox: _vm.verbalCheckBoxChanged },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.messagingDescriptionData.verbalCheckBox.isCheck,
                  expression: "messagingDescriptionData.verbalCheckBox.isCheck",
                },
              ],
              attrs: { slot: "messaging-description-check-box-body" },
              slot: "messaging-description-check-box-body",
            },
            [
              _c("div", { staticClass: "verbal-sub-header" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        "smsRegistrations.messagingDescriptionVerbalCheckBoxDescriptionSubHeader"
                      )
                    ),
                  },
                }),
              ]),
              _c(
                "div",
                { staticClass: "verbal-text-area" },
                [
                  _c("vwc-textarea", {
                    staticClass: "verbal-message",
                    attrs: {
                      required: "",
                      outlined: "",
                      dense: "",
                      disabled: _vm.readOnly,
                      readOnly:
                        !_vm.messagingDescriptionData.verbalCheckBox
                          .verbalEditEnable,
                      rows: "5",
                      value:
                        _vm.messagingDescriptionData.verbalCheckBox.describe,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.handleVerbalDescribe($event.target.value)
                      },
                    },
                  }),
                  _c("vwc-icon-button", {
                    staticClass: "verbal-edit-icon",
                    attrs: {
                      disabled:
                        _vm.readOnly ||
                        _vm.messagingDescriptionData.verbalCheckBox
                          .verbalEditEnable,
                      icon: "edit-line",
                    },
                    on: { click: _vm.handleVerbalEdit },
                  }),
                  _c("vwc-icon-button", {
                    staticClass: "reset-icon",
                    attrs: {
                      disabled:
                        _vm.readOnly ||
                        !_vm.messagingDescriptionData.verbalCheckBox
                          .verbalEditEnable,
                      icon: "reset-line",
                    },
                    on: { click: _vm.handleVerbalReset },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "messaging-description-check-box",
        {
          staticClass: "messaging-description-check-box",
          attrs: {
            "tool-tip-info": _vm.toolTips[2],
            "is-ack-checked":
              _vm.messagingDescriptionData.paperCheckBox.isCheck,
            header: _vm.messagingDescriptionData.paperCheckBox.header,
            disabled: _vm.readOnly,
            "data-cy": "messaging-description-paper-check-box",
          },
          on: { checkBox: _vm.paperCheckBoxChanged },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.messagingDescriptionData.paperCheckBox.isCheck,
                  expression: "messagingDescriptionData.paperCheckBox.isCheck",
                },
              ],
              attrs: { slot: "messaging-description-check-box-body" },
              slot: "messaging-description-check-box-body",
            },
            [
              _c("div", { staticClass: "all-steps-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberOneSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionPaperCheckBoxStep1"
                              )
                            )
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "disclaimer-note" },
                        [
                          _c("vwc-icon", {
                            staticClass: "privacy-icon",
                            attrs: { type: "quote-line" },
                          }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.onlineAndPaperDisclaimer)),
                          ]),
                          _c(
                            "div",
                            [
                              _c("vwc-icon-button", {
                                staticClass: "copy-icon-disclaimer",
                                attrs: {
                                  connotation: "cta",
                                  icon: "copy-2-line",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(
                                      _vm.onlineAndPaperDisclaimer
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "info-note" },
                        [
                          _c("vwc-icon", {
                            staticClass: "info-icon",
                            attrs: { type: "info-line" },
                          }),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "smsRegistrations.messagingDescriptionPaperCheckBoxStep1InfoNote"
                                )
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberTwoSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionPaperCheckBoxStep2"
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberThreeSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionPaperCheckBoxStep3"
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberFourSVG"),
                    _c(
                      "div",
                      { staticClass: "step-content" },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "smsRegistrations.messagingDescriptionPaperCheckBoxStep4"
                                )
                              )
                          ),
                        ]),
                        _c("text-field", {
                          staticClass: "url-textField",
                          attrs: {
                            disabled: _vm.readOnly,
                            "data-cy":
                              "description-paper-form-checkbox-url-input",
                            "validation-message": _vm.webSiteValidation(
                              _vm.messagingDescriptionData.paperCheckBox.url
                            ),
                            pattern: _vm.regexPatterns.webSiteRegex,
                            value:
                              _vm.messagingDescriptionData.paperCheckBox.url,
                            placeholder: _vm.$t(
                              "smsRegistrations.messagingDescriptionOnlineCheckBoxUrlPlaceHolder"
                            ),
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.messagingDescriptionData.paperCheckBox.url =
                                $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberFiveSVG"),
                    _c(
                      "div",
                      { staticClass: "step-content" },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "smsRegistrations.messagingDescriptionPaperCheckBoxStep5"
                                )
                              )
                          ),
                        ]),
                        _c("text-field", {
                          staticClass: "describe-text-field",
                          attrs: {
                            disabled: _vm.readOnly,
                            "data-cy": "description-paper-form-checkbox-input",
                            "char-counter": true,
                            "max-length": "150",
                            value:
                              _vm.messagingDescriptionData.paperCheckBox
                                .describe,
                            placeholder: _vm.$t(
                              "smsRegistrations.messagingDescriptionPaperCheckBoxDescriptionPlaceHolder"
                            ),
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.messagingDescriptionData.paperCheckBox.describe =
                                $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "messaging-description-check-box",
        {
          staticClass: "messaging-description-check-box",
          attrs: {
            "tool-tip-info": _vm.toolTips[0],
            "is-ack-checked":
              _vm.messagingDescriptionData.onlineCheckBox.isCheck,
            header: _vm.messagingDescriptionData.onlineCheckBox.header,
            disabled: _vm.readOnly,
            "data-cy": "messaging-description-online-check-box",
          },
          on: { checkBox: _vm.onlineCheckBoxChanged },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.messagingDescriptionData.onlineCheckBox.isCheck,
                  expression: "messagingDescriptionData.onlineCheckBox.isCheck",
                },
              ],
              staticClass: "online-textFields-wrapper",
              attrs: { slot: "messaging-description-check-box-body" },
              slot: "messaging-description-check-box-body",
            },
            [
              _c("div", { staticClass: "all-steps-wrapper" }, [
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberOneSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionOnlineCheckBoxStep1"
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberTwoSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionOnlineCheckBoxStep2"
                              )
                            )
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "disclaimer-note" },
                        [
                          _c("vwc-icon", {
                            staticClass: "privacy-icon",
                            attrs: { type: "quote-line" },
                          }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.onlineAndPaperDisclaimer)),
                          ]),
                          _c(
                            "div",
                            [
                              _c("vwc-icon-button", {
                                staticClass: "copy-icon-disclaimer",
                                attrs: {
                                  connotation: "cta",
                                  icon: "copy-2-line",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.copy(
                                      _vm.onlineAndPaperDisclaimer
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberThreeSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionOnlineCheckBoxStep3"
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberFourSVG"),
                    _c("div", { staticClass: "step-content" }, [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "smsRegistrations.messagingDescriptionOnlineCheckBoxStep4"
                              )
                            )
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberFiveSVG"),
                    _c(
                      "div",
                      { staticClass: "step-content" },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "smsRegistrations.messagingDescriptionOnlineCheckBoxStep5"
                                )
                              )
                          ),
                        ]),
                        _c("text-field", {
                          staticClass: "url-textField",
                          attrs: {
                            disabled: _vm.readOnly,
                            "data-cy": "description-online-checkbox-url-input",
                            "validation-message": _vm.webSiteValidation(
                              _vm.messagingDescriptionData.onlineCheckBox.url
                            ),
                            pattern: _vm.regexPatterns.webSiteRegex,
                            value:
                              _vm.messagingDescriptionData.onlineCheckBox.url,
                            placeholder: _vm.$t(
                              "smsRegistrations.messagingDescriptionOnlineCheckBoxUrlPlaceHolder"
                            ),
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.messagingDescriptionData.onlineCheckBox.url =
                                $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paper-step-wrapper" },
                  [
                    _c("NumberSixSVG"),
                    _c(
                      "div",
                      { staticClass: "step-content" },
                      [
                        _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "smsRegistrations.messagingDescriptionOnlineCheckBoxStep6"
                                )
                              )
                          ),
                        ]),
                        _c("text-field", {
                          staticClass: "describe-text-field",
                          attrs: {
                            disabled: _vm.readOnly,
                            "data-cy":
                              "description-online-checkbox-description-input",
                            value:
                              _vm.messagingDescriptionData.onlineCheckBox
                                .describe,
                            "char-counter": true,
                            "max-length": "150",
                            placeholder: _vm.$t(
                              "smsRegistrations.messagingDescriptionOnlineCheckBoxDescriptionPlaceHolder"
                            ),
                          },
                          on: {
                            textChanged: function ($event) {
                              _vm.messagingDescriptionData.onlineCheckBox.describe =
                                $event
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]
      ),
      _c("br"),
      _c("div", { staticClass: "business-type-verification" }, [
        _c("h5", [_vm._v("SMS usage")]),
        _c(
          "div",
          { staticClass: "radio-options-container" },
          _vm._l(_vm.businessTypeOptions, function (option) {
            return _c(
              "div",
              { key: option.value, staticClass: "radio-option" },
              [
                _c(
                  "VRadioGroup",
                  {
                    key: _vm.localBusinessType,
                    attrs: { disabled: _vm.readOnly },
                    model: {
                      value: _vm.localBusinessType,
                      callback: function ($$v) {
                        _vm.localBusinessType = $$v
                      },
                      expression: "localBusinessType",
                    },
                  },
                  [
                    _c("VRadio", {
                      ref: "businessType_" + option.value,
                      refInFor: true,
                      attrs: {
                        id: "business-type-" + option.value,
                        "data-cy": `business-type-radio-${option.value}`,
                        value: option.value,
                        label: option.label,
                      },
                    }),
                  ],
                  1
                ),
                _vm.localBusinessType === option.value && option.checkboxText
                  ? _c(
                      "div",
                      { staticClass: "sms-usage-acknowledgment" },
                      [
                        _c("VCheckbox", {
                          attrs: {
                            disabled: _vm.readOnly,
                            label: option.checkboxText,
                            "data-cy": `sms-usage-checkbox-${option.value}`,
                          },
                          model: {
                            value: _vm.isSmsAckChecked,
                            callback: function ($$v) {
                              _vm.isSmsAckChecked = $$v
                            },
                            expression: "isSmsAckChecked",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("br"),
      _c("div", { staticClass: "privacy-policy-div" }, [
        _c("h5", [_vm._v("Privacy Policy Verification")]),
        _c("p", { staticClass: "description-sub-title" }, [
          _vm._v("Does your business website include a Privacy Policy?"),
        ]),
        _vm.isBulkSms
          ? _c("div", { staticClass: "privacy-radio-stack" }, [
              _c("label", { staticClass: "privacy-native-radio-label" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "privacyPolicyRadio",
                    value: "false",
                    disabled: _vm.readOnly,
                    "data-cy": "no-radio",
                  },
                  domProps: { checked: _vm.privacyRadio === "false" },
                  on: {
                    change: function ($event) {
                      _vm.privacyRadio = "false"
                      _vm.privacyRadioDeclined($event)
                    },
                  },
                }),
                _c("span", [_vm._v("No")]),
              ]),
              _vm.isBulkSms && _vm.privacyRadio === "false"
                ? _c(
                    "div",
                    { staticClass: "privacy-checkbox-container" },
                    [
                      _c("VCheckbox", {
                        attrs: {
                          disabled: _vm.readOnly,
                          label:
                            "We acknowledge that the following disclosure is present upon obtaining customer opt in.",
                          "data-cy": "privacy-checkbox",
                        },
                        model: {
                          value: _vm.privacyCheckbox,
                          callback: function ($$v) {
                            _vm.privacyCheckbox = $$v
                          },
                          expression: "privacyCheckbox",
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "disclaimer-note" },
                        [
                          _c("vwc-icon", {
                            staticClass: "privacy-icon",
                            attrs: { type: "quote-line" },
                          }),
                          _c("span", [
                            _vm._v(_vm._s(_vm.privacyPolicyDisclaimer)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c("label", { staticClass: "privacy-native-radio-label" }, [
                _c("input", {
                  attrs: {
                    type: "radio",
                    name: "privacyPolicyRadio",
                    value: "true",
                    disabled: _vm.readOnly,
                    "data-cy": "yes-radio",
                  },
                  domProps: { checked: _vm.privacyRadio === "true" },
                  on: {
                    change: function ($event) {
                      _vm.privacyRadio = "true"
                      _vm.privacyRadioAccepted($event)
                    },
                  },
                }),
                _c("span", [_vm._v("Yes")]),
              ]),
            ])
          : _vm._e(),
        !_vm.isBulkSms
          ? _c(
              "div",
              [
                _c(
                  "VRadioGroup",
                  {
                    staticClass: "privacy-radio",
                    attrs: { disabled: _vm.readOnly, orientation: "vertical" },
                    model: {
                      value: _vm.privacyRadio,
                      callback: function ($$v) {
                        _vm.privacyRadio = $$v
                      },
                      expression: "privacyRadio",
                    },
                  },
                  [
                    _c("VRadio", {
                      attrs: {
                        label: "No",
                        value: "false",
                        "data-cy": "no-radio",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.privacyRadioDeclined($event)
                        },
                      },
                    }),
                    _c("VRadio", {
                      attrs: {
                        label: "Yes",
                        value: "true",
                        "data-cy": "yes-radio",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.privacyRadioAccepted($event)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.isBulkSms && _vm.privacyRadio === "true"
          ? _c(
              "div",
              { staticClass: "privacy-checkbox-container" },
              [
                _c(
                  "label",
                  {
                    staticClass: "bsf-label",
                    staticStyle: {
                      "font-size": "11px",
                      "font-weight": "600",
                      color: "#555",
                      "text-transform": "uppercase",
                      "letter-spacing": "0.4px",
                    },
                  },
                  [_vm._v("Privacy Policy Link")]
                ),
                _c(
                  "p",
                  {
                    staticStyle: {
                      "font-size": "13px",
                      color: "#666",
                      margin: "4px 0 8px",
                    },
                  },
                  [
                    _vm._v(
                      "Provide a link to the Privacy Policy that covers how you collect and use customer data, including mobile phone numbers."
                    ),
                  ]
                ),
                _c("text-field", {
                  staticClass: "url-textField",
                  staticStyle: { "max-width": "100%" },
                  attrs: {
                    disabled: _vm.readOnly,
                    "data-cy": "bulk-sms-privacy-policy-url-input",
                    "validation-message": _vm.webSiteValidation(
                      _vm.messagingDescriptionData.linkToPrivacyPolicy
                    ),
                    pattern: _vm.regexPatterns.webSiteRegex,
                    value: _vm.messagingDescriptionData.linkToPrivacyPolicy,
                    placeholder: "https://",
                    "char-counter": true,
                    "max-length": "2048",
                  },
                  on: {
                    textChanged: function ($event) {
                      _vm.messagingDescriptionData.linkToPrivacyPolicy = $event
                    },
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        !_vm.isBulkSms && _vm.privacyRadio === "true"
          ? _c(
              "div",
              { staticClass: "privacy-checkbox-container" },
              [
                _c("VCheckbox", {
                  attrs: {
                    disabled: _vm.readOnly,
                    label:
                      "We acknowledge that the following disclosure is included in our Privacy Policy.",
                    "data-cy": "privacy-checkbox",
                  },
                  model: {
                    value: _vm.privacyCheckbox,
                    callback: function ($$v) {
                      _vm.privacyCheckbox = $$v
                    },
                    expression: "privacyCheckbox",
                  },
                }),
                _c(
                  "div",
                  { staticClass: "disclaimer-note" },
                  [
                    _c("vwc-icon", {
                      staticClass: "privacy-icon",
                      attrs: { type: "quote-line" },
                    }),
                    _c("span", [_vm._v(_vm._s(_vm.privacyPolicyDisclaimer))]),
                    _c(
                      "div",
                      [
                        _c("vwc-icon-button", {
                          staticClass: "copy-icon-disclaimer",
                          attrs: { connotation: "cta", icon: "copy-2-line" },
                          on: {
                            click: function ($event) {
                              return _vm.copy(_vm.privacyPolicyDisclaimer)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }